var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"informatio no-data"},[_c('i',{staticClass:"icon icon-no-data-td"}),_vm._v(" "),_c('p',[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.mlang('noResults'))+"\n    ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }